import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { ICrumb } from '@df/catalog/model';
import { StructuralData } from '@df/core/meta/structural-data/structural-data.namespace';
import { StructuralDataService } from '@df/core/meta/structural-data/structural-data.service';
import { LocalICmsPage } from '../../../catalog/page/local/local-page';
declare module '@df/core/meta/structural-data/structural-data.namespace' {
    export namespace StructuralData {
        export enum Type {
            blogPosting = 'BlogPosting'
        }
    }
}

export interface IBlogPostingData extends StructuralData.IData<StructuralData.Type.blogPosting> {
    '@context': 'http://schema.org';
    mainEntityOfPage?: StructuralData.IWebpageData;
    headline?: string;
    alternativeHeadline?: string;
    datePublished?: string;
    dateModified?: string;
    dateCreated?: string;
    author?: StructuralData.IPersonData | StructuralData.IOrganizationData;
    image?: string | string[] | StructuralData.IImageObjectData;
    publisher?: StructuralData.IOrganizationData;
    award?: string;
    editor?: StructuralData.IPersonData;
    genre?: string;
    keywords?: string;
    wordCount?: number;
    url?: StructuralData.IWebpageData;
    description?: string;
    articleBody?: string;
}

@Injectable({
    providedIn: 'root'
})
export class LocalStructuralDataService extends StructuralDataService {
    override addBreadcrumbsData(breadcrumbs?: ICrumb[]): void {
        if (breadcrumbs) {
            const items = this.getBreadcrumbsData(breadcrumbs);
            if (items && items.length) {
                if (this.isYourHouseBlogArticle()) {
                    const model = this.meta.model as any as LocalICmsPage<IPageDataV3>;
                    const datePipe = new DatePipe(this.app.data.locale || 'en-GB');
                    const blogPostingData: IBlogPostingData = {
                        '@context': 'http://schema.org',
                        '@type': 'BlogPosting' as StructuralData.Type.blogPosting,
                        mainEntityOfPage: {
                            '@type': StructuralData.Type.webpage,
                            '@id': this.app.url.toUrl(this.url.getPath())
                        },
                        headline: model.data?.meta?.title,
                        description: model.data?.meta?.description,
                        image: model.data?.image && [this.app.url.toUrl(model.data?.image)] || undefined,
                        author: {
                            '@type': StructuralData.Type.organization,
                            name: 'Barker and Stonehouse',
                            url: this.url.toUrl('/')
                        },
                        publisher: {
                            '@type': StructuralData.Type.organization,
                            name: 'Barker and Stonehouse',
                            logo: {
                                '@type': StructuralData.Type.imageObject,
                                url: this.url.toUrl('static/cms/media/logo.svg')
                            }
                        },
                        dateModified: datePipe.transform(model.data?.updatedAt, 'yyyy-MM-dd') || undefined,
                        datePublished: datePipe.transform(model.data?.typeData.date, 'yyyy-MM-dd') || undefined,
                    };
                    this.add(blogPostingData);
                }
                const data: StructuralData.IBreadcrumbsListData = {
                    '@context': 'http://schema.org',
                    '@type': StructuralData.Type.breadcrumbList,
                    itemListElement: items
                };
                this.add(data);
            }
        }
    }
    isYourHouseBlogArticle(): boolean {
        const url = this.meta?.model?.data?.url || '';
        const regex = /^\/yourhouse\/?.*/;
        return regex.test(url);
    }
}
